module.exports = __webpack_public_path__ + "static/media/login-bg.53d73a36.jpg";